import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';

import { services } from '../../services';

export const useGetRecognitionProducts = (code, options = {}) =>
  useQuery([QUERY_KEYS.useGetRecognitionProductsKey, code], () => services.products(code), {
    staleTime: 20 * 1000,
    ...options
  });
